import React from 'react';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import EditFreelancerUserHelper from './EditFreelancerUserHelper';
import FreelancerAgencyUserTypesEnum from '../../../Enums/FreelancerAgencyUserTypesEnum';
import FreelancerUserManagerEditItem from '../../../Domain/FreelancerUserManagerEditItem';
import TpAdminService from '../../../Services/TpAdminService';
import DepartmentEnum from '../../../Enums/DepartmentEnum';

export default class AddManagerWindowDescription {
  static titleForCreate = 'Add Manager';

  static itemType = FreelancerUserManagerEditItem;
  static serviceFunction = (edited) => TpAdminService.AddFreelancerUserManager(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ThirdPartySource',
          label: 'Third Party Source',
          className: 'col-12',
          type: InputTypesEnum.ThirdPartySourceSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'DepartmentLookupItemValue',
          label: 'Department',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: (editedItem) => AddManagerWindowDescription.getDepartmentSelectValues(editedItem),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ManagerId',
          label: 'Third Party Manager',
          className: 'col-12',
          type: InputTypesEnum.FreelancerUserManagerSelect,
          validityChecker: AddManagerWindowDescription.validityCheckerForManagers,
          idFilterArray: ['FreelancerUserId', 'ThirdPartySource', 'DepartmentLookupItemValue'],
          disabled: (item) =>
            !item.ThirdPartySource ||
            !item.FreelancerRoleIds.some((x) => x.toString() === item.DepartmentLookupItemValue?.toString()),
        },
      ],
    },
  ];

  static getDepartmentSelectValues(editedItem) {
    const values = [{ value: null, label: 'Select a Department...' }];

    if (editedItem.FreelancerRoleIds.includes(DepartmentEnum.RM)) {
      values.push({ value: DepartmentEnum.RM, label: 'Resource Management' });
    }

    if (editedItem.FreelancerRoleIds.includes(DepartmentEnum.DQ)) {
      values.push({ value: DepartmentEnum.DQ, label: 'Data Quality' });
    }

    if (values.length === 0) {
      values.push({ value: '', label: 'No eligible departments assigned' });
    }

    return values;
  }

  static validityCheckerForManagers(e, editedItem) {
    const department = editedItem.DepartmentLookupItemValue;
    if (!editedItem.FreelancerRoleIds.some((x) => x.toString() === department?.toString())) {
      return 'The vendor is not assigned to this department.';
    }

    if (editedItem.UserType === FreelancerAgencyUserTypesEnum.Agency) {
      return '';
    }

    if (
      department === DepartmentEnum.RM &&
      editedItem.RmFreelancerUserManagers?.some((m) => m === editedItem.ThirdPartySource)
    ) {
      return 'An RM manager is already assigned for this Third Party Source.';
    }

    if (
      department === DepartmentEnum.DQ &&
      editedItem.DqFreelancerUserManagers?.some((m) => m === editedItem.ThirdPartySource)
    ) {
      return 'A DQ manager is already assigned for this Third Party Source.';
    }

    if (ValidityHelper.forRequiredTextField(editedItem.ManagerId) !== '') {
      return ValidityHelper.forRequiredTextField(editedItem.ManagerId);
    }

    return EditFreelancerUserHelper.validityCheckerDataExistsInDatabase(
      'ManagersDQorRM',
      `${editedItem.ThirdPartySource};${department};${editedItem.ManagerId}`,
      'This manager ID within this department belongs to another user.',
      editedItem.FreelancerUserId
    );
  }
}
